import { render } from "./NBAOverlay.vue?vue&type=template&id=d4a3307a&scoped=true"
import script from "./NBAOverlay.vue?vue&type=script&lang=js"
export * from "./NBAOverlay.vue?vue&type=script&lang=js"

import "./NBAOverlay.vue?vue&type=style&index=0&id=d4a3307a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4a3307a"]])

export default __exports__